module.exports = __webpack_public_path__ + "static/worqpass-ac94d3a3e5c1d97f25ff3f879b5c0e8d.svg";